import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import Section from '../../components/Section';
import {
  selectSelectionMethod, getPlants,
  setSelectionMethod, setSelectedPlantIds,
} from '../../ducks/plants';
import SelectableCard from '../../components/SelectableCard';
import {
  plantSelectionEnum,
  plantSelectionTypesEnum,
} from '../../ducks/plants/types';
import { componentsEnum } from '../../utils/types';

export default function PlantSelectionMethod(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const selectionMethod = useSelector(selectSelectionMethod);

  const handleNextSectionClick = () => {
    dispatch(getPlants());

    // todo: check if this works
    if (selectionMethod === plantSelectionEnum.none) {
      dispatch(setSelectedPlantIds({
        selectionType: plantSelectionTypesEnum.presentAccordingToUserIds,
        plantIds: [],
      }));
    }
  };

  return (
    <Section
      previousNav={{
        disabled: false,
        handleClick: () => history.push(
          componentsEnum.properties[componentsEnum.beeSelection].route,
        ),
      }}
      nextNav={{
        disabled: !selectionMethod,
        handleClick: handleNextSectionClick,
      }}
      {...props}
    >
      <Row className="justify-content-md-center">
        <Col className="text-center" md={10}>
          <h2>Huidige beplanting</h2>
          <p>
            Deze stap biedt je de mogelijkheid om de huidige beplanting in jouw gebied in kaart te
            brengen om zo de bloeiboog zo compleet mogelijk te maken.
          </p>
        </Col>
      </Row>
      <Row>
        <Col className="text-center mb-2">
          <small>Kies één van de onderstaande opties</small>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md={4} className="mb-3 mb-md-0">
          <SelectableCard
            title="Beplanting invullen"
            description="Kies deze optie om bestaande beplanting in te vullen, mogelijk met behulp van het model."
            handleClick={() => dispatch(setSelectionMethod(plantSelectionEnum.automatic))}
            selected={selectionMethod === plantSelectionEnum.automatic}
          />
        </Col>
        <Col md={4} className="mb-3 mb-md-0">
          <SelectableCard
            title="Geen beplanting"
            description="Als je een nog niet beplant gebied gaat beplanten, kies je deze optie."
            handleClick={() => dispatch(setSelectionMethod(plantSelectionEnum.none))}
            selected={selectionMethod === plantSelectionEnum.none}
          />
        </Col>
      </Row>
    </Section>
  );
}
